<template>
    <div>
        <div class="mainTop cf">
            <navZcy v-bind:num="1"></navZcy>
            <management></management>
        </div>
        <div>
            <div class="aside">
                <el-tabs :tab-position="leftTab" style="height: 1000px;" @tab-click="handleSelect" v-model="activeName">
                    <el-tab-pane label="视频素材" name="videoZcy"></el-tab-pane>
                    <el-tab-pane label="播放清单" name="detailedList"></el-tab-pane>
                </el-tabs>
            </div>
            <!--<div class="aside">
                <div>
                    <el-menu
                            default-active="video"
                            class="el-menu-vertical-demo"
                            @select="handleSelect">
                        <el-submenu index="1">
                            <template slot="title">
                                <i class="el-icon-location"></i>
                                <span>视频管理</span>
                            </template>
                            <el-menu-item index="video">视频素材</el-menu-item>
                            <el-menu-item index="detailedList">播放清单</el-menu-item>
                        </el-submenu>

                    </el-menu>
                </div>
            </div>-->
            <!--<div class="main">
                <div v-if="flag">
                    <videoZcy></videoZcy>
                </div>
                <div v-else>
                    <detailedList></detailedList>
                </div>
            </div>-->

            <el-col :span="21">
                <div style="margin-left: 10px;margin-top: 10px;">
                    <div style="margin-bottom: 10px;">
                        <a>工作台</a>
                    </div>

                    <el-tabs v-model="editableTabsValue" type="card" closable   @tab-remove="removeTab">
                        <el-tab-pane
                                v-for="(item) in tabData"
                                :key="item.id"
                                :name="item.name"
                                :label="item.label"
                        >
                            <component v-bind:is="item.cmpname" ></component>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
        </div>
    </div>
</template>

<script>
    import management from './management.vue'
    import navZcy from './nav.vue'
    import videoZcy from './video.vue'
    import detailedList from './detailedList.vue'
    export default {
        name: "videoManager",
        components:{
            management,
            navZcy,
            videoZcy,
            detailedList
        },
        data(){
            return{
                flag:true,
                leftTab: 'left',
                activeName: '',
                editableTabsValue:'',
                tabIndex:0,
                tabData:[],
                componentMap: {
                    videoZcy: {
                        name: '视频素材',
                        single: true,
                    },
                    detailedList: {
                        name: '播放清单',
                        single: true
                    },
                }
            }
        },
        methods:{
            handleSelect(tag){
                var createNew = true
                var existNodeName = ''
                if (this.componentMap[tag.name].single) {
                    for (let i = 0; i < this.tabData.length; i++) {
                        if (this.tabData[i].cmpname == tag.name) {
                            existNodeName = this.tabData[i].name
                            createNew = false
                            break
                        }
                    }
                }
                if (createNew) {
                    let newName = tag.name + this.tabIndex
                    let obj = {
                        name: newName,
                        label: this.componentMap[tag.name].single ? this.componentMap[tag.name].name : this.componentMap[tag.name].name + this.tabIndex,
                        cmpname: tag.name,
                        id: this.tabIndex
                    }
                    console.log(obj)
                    this.tabData.unshift(obj)
                    this.tabIndex = this.tabIndex + 1
                    this.editableTabsValue = newName
                } else {
                    this.editableTabsValue = existNodeName
                }
            },
            removeTab(targetName) {
                for (let i = 0; i < this.tabData.length; i++) {
                    if (this.tabData[i].name == targetName) {
                        this.tabData.splice(i, 1)
                        break
                    }
                }
            },
        },
    }
</script>

<style scoped>
    .aside{
        width: 11%;
        float: left;
    }
    .main{
        width: 89%;
        float:right;
    }
</style>
